var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-item-box"},[(_vm.icon)?_c('svg-icon',{staticStyle:{"width":"30px","height":"30px"},attrs:{"iconClass":_vm.icon}}):_vm._e(),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }